import { cloneDeep, findIndex } from 'lodash';
import { ColumnMangerOptionType } from '../../../../../common';

export const createDropdownOptions = (options: string[], active: string[]): ColumnMangerOptionType[] => {
	return options.map((o, i) => {
		const option: ColumnMangerOptionType = {
			value: o,
			label: o,
			isChecked: active.includes(o),
			isDisabled: false,
		};
		if (i === 0) {
			option.isDisabled = true;
		}
		return option;
	});
};

export const getUpdateOptions = (
	option: ColumnMangerOptionType,
	options: ColumnMangerOptionType[]
): ColumnMangerOptionType[] => {
	const state = cloneDeep(options);
	const optionIndex = findIndex(state, ['value', option.value]);
	if (optionIndex !== -1) {
		const currentStatus = Boolean(state[optionIndex]?.isChecked);
		state[optionIndex].isChecked = !currentStatus;
	}
	return state;
};

export const getColumnValues = (options: ColumnMangerOptionType[]): string[] => {
	return options.filter((item) => item.isChecked).map((item) => item.value);
};
